// extracted by mini-css-extract-plugin
module.exports = {"locationList":"slide-link_locationList__1Olnq","itemList":"slide-link_itemList__1n4t8","item":"slide-link_item__19FLb"};